
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wedstrijd",
      function () {
        return require("private-next-pages/wedstrijd/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wedstrijd"])
      });
    }
  